module.exports = __webpack_public_path__ + "static/assets/e6ed36fccdd208479cacfbec1a64ac4b.png";